import React from 'react';
import { LaptopImg } from './elements';
import { 
  PageWrapper,
  FlexDiv, 
  Text, 
  Container, 
} from '@Main/elements';
import { P } from '@helpers';
import { getImage } from "gatsby-plugin-image";

export const StylingElement = ({getPng, t}) => {
    return (
      <PageWrapper darkMode={false}>
        <FlexDiv>
          <LaptopImg image={getImage(getPng('laptop'))} alt="laptop" />
          <Text width='350px' marginLeft='30px' marginTop='50px' paddingBefforeText="45px">
            <h1>{t("Styling elements")}</h1>
            <p>
              {t("Styling elements are design concepts to guide the graphic design of a particular media piece. They are in strict accordance with the mission and goals of the company.")}
            </p>
          </Text>
        </FlexDiv>
        <Container width='535px' marginTop='57px' marginLeft='102px' paddingBottom='96px'>
            <P weight='600' size='15px' height='30px'>{t("Key visual forming principles")}</P>
            <P weight='400' size='15px' height='30px' paddingBottom='38px' paddingTop='38px'>
              {t("We are inspired by technological advances, technology evangelists, and the pursuit of development.")}
            </P>
            <P weight='400' size='15px' height='30px' paddingBottom='38px'>
              {t("We create products for customers who are looking for highly developed, reliable technology and new solutions for the expansion of their businesses.")}
            </P>
            <P weight='400' size='15px' height='30px' paddingBottom='38px'>
              {t("Our team members are interested in technological innovations and also strive for external and internal integrity. Therefore, the subject of our corporate events is often healthy lifestyle, sports, and nature exploration.")}
            </P>
            <P weight='400' size='15px' height='30px'>
              {t("If our company could be represented as an individual, it would be a professional who tirelessly evolves in their field and looks for new ways to solve problems, and is involved in one or more sports activities.")}
            </P>
        </Container>
     </PageWrapper>
  );
};
